/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchOverride } from './SearchOverride';
import {
    SearchOverrideFromJSON,
    SearchOverrideFromJSONTyped,
    SearchOverrideToJSON,
} from './SearchOverride';

/**
 * 
 * @export
 * @interface SearchOverridesResponse
 */
export interface SearchOverridesResponse {
    /**
     * 
     * @type {Array<SearchOverride>}
     * @memberof SearchOverridesResponse
     */
    overrides: Array<SearchOverride>;
}

/**
 * Check if a given object implements the SearchOverridesResponse interface.
 */
export function instanceOfSearchOverridesResponse(value: object): value is SearchOverridesResponse {
    if (!('overrides' in value) || value['overrides'] === undefined) return false;
    return true;
}

export function SearchOverridesResponseFromJSON(json: any): SearchOverridesResponse {
    return SearchOverridesResponseFromJSONTyped(json, false);
}

export function SearchOverridesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchOverridesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'overrides': ((json['overrides'] as Array<any>).map(SearchOverrideFromJSON)),
    };
}

export function SearchOverridesResponseToJSON(value?: SearchOverridesResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'overrides': ((value['overrides'] as Array<any>).map(SearchOverrideToJSON)),
    };
}

